import React, { useEffect, useRef } from 'react';
const {tableau} = window

export default function TableauMonthlySales() {
  const ref = useRef(null)
  const url =  "https://public.tableau.com/views/Monthly_16557972561680/MonthlySaleNet?:language=en-US&:display_count=n&:showShareOptions=false&:origin=viz_share_link"

  const options = {
    hideTabs: true,
    hideToolbar: true,
  }

  function initViz(){
    new tableau.Viz(ref.current, url, options)
  }

  useEffect(() => {
    initViz()
  }, [])

  return (
    <div ref={ref} style={{width:'100%', height:'100vh'}}></div>
  )
}